import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-06jurassic_HorCenter_fenbu",
  "use": "icon-06jurassic_HorCenter_fenbu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-06jurassic_HorCenter_fenbu\"><path d=\"M765 64v896h-64V64zM352 64v896h-64V64z\" fill=\"#727272\" /><path d=\"M832 320v384H640V320z\" fill=\"#B3B3B3\" /><path d=\"M448 192v640H192V192z\" fill=\"#497CAD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol